$(document).ready(function () {
  $(document).on("click", 'fieldset.js input[type="radio"]', function () {
    console.log("dev checking ");
    var selectedVariant = $(this).val();
    var variantPreOrderDate = $(this).data("pre-order-date");
    var remaining_quantity = $(this).data("quan");
    var remaining_quantity_div = $(".remaining_quantity");
    var productInfo = remaining_quantity_div.closest(".product-info");
    var dataSection = productInfo.data("section");

    var remaining_quantity_text = $(".remaining_quantity .product__inventory");
    var remaining_quantity_bar = $(
      ".remaining_quantity .inventory-progress-container .inventory-progress-bar"
    );
    if (remaining_quantity < 16) {
      if (remaining_quantity_div.hasClass("quantity_hide")) {
        remaining_quantity_div.removeClass("quantity_hide");
      }
      if (remaining_quantity_text.length > 0) {
        remaining_quantity_text
          .find("span")
          .text(`Hurry, only ${remaining_quantity} left in stock!`);
      } else {
        var new_html = `<p class="product__inventory" id="Inventory-${dataSection}" role="status">
                                <span>Hurry, only ${remaining_quantity} left in stock!</span>
                            </p>`;
        remaining_quantity_div.append(new_html);
      }
      if (remaining_quantity_bar.length > 0) {
        var percentage = (remaining_quantity * 100) / 16;
        remaining_quantity_bar.css("width", percentage + "%");
      } else {
        var percentage = (remaining_quantity * 100) / 16;
        var progressHTML = `
            <div class="inventory-progress-container">
              <div class="inventory-progress-bar" style="width: ${percentage}%;"></div>
            </div>
          `;
        remaining_quantity_div.append(progressHTML);
      }
    } else {
      if (!remaining_quantity_div.hasClass("quantity_hide")) {
        remaining_quantity_div.addClass("quantity_hide");
      }
    }

    setTimeout(function () {
      var gettxt = $(
        ".product__info-wrapper.grid__item .price-item.price-item--last"
      ).text();
      var cleanedPrice = gettxt.replace(/[^$0-9.,]/g, "");

      cleanedPrice = cleanedPrice.replace(/^\./, "");
      // console.log(cleanedPrice, "product");

      $(".btn_price").text(cleanedPrice);
      /*  if (
              $(".product-form__submit.button--full-width.button--primary").is(
                ":disabled"
              )
            ) {
              $("#BIS_trigger").show(); // Show the BIS trigger button
            } else {
              $("#BIS_trigger").hide(); // Hide the BIS trigger button
            } */

      var preOrderDateHidden = $(".pre_order_date_class");
      if (!variantPreOrderDate) {
        $(".preorder_date").addClass("empty");
        $("#variantAdditionalInfo").html("");
        preOrderDateHidden.val("");
        $(".product-form__submit").removeClass("pre-order-button");
      } else {
        $(".preorder_date").removeClass("empty");
        $("#variantAdditionalInfo").html(
          "<strong>Pre-Order Date:</strong> " + variantPreOrderDate
        );
        preOrderDateHidden.val(variantPreOrderDate);
        $(".product-form__submit").addClass("pre-order-button");
      }
    }, 1500);
  });
});

function onChangeVariantAjax() {
  var checkedVariant = $("input[name^='Size']:checked");
  var pre_order_date = checkedVariant.data("pre-order-date");
  var preOrderDateHidden = $(".pre_order_date_class");
  if (!pre_order_date) {
    $(".preorder_date").addClass("empty");
    $("#variantAdditionalInfo").html("");
    preOrderDateHidden.val("");
    $(".product-form__submit").removeClass("pre-order-button");
  } else {
    $(".preorder_date").removeClass("empty");
    $("#variantAdditionalInfo").html(
      "<strong>Pre-Order Date:</strong> " + pre_order_date
    );
    $(".product-form__submit").addClass("pre-order-button");
    preOrderDateHidden.val(variantPreOrderDate);
  }
  var remaining_quantity = checkedVariant.data("quan");
  var remaining_quantity_div = $(".remaining_quantity");
  var productInfo = remaining_quantity_div.closest(".product-info");
  var dataSection = productInfo.data("section");
  var remaining_quantity_text = $(".remaining_quantity .product__inventory");
  var remaining_quantity_bar = $(
    ".remaining_quantity .inventory-progress-container .inventory-progress-bar"
  );
  if (remaining_quantity < 16) {
    if (remaining_quantity_div.hasClass("quantity_hide")) {
      remaining_quantity_div.removeClass("quantity_hide");
    }
    if (remaining_quantity_text.length > 0) {
      remaining_quantity_text
        .find("span")
        .text(`Hurry, only ${remaining_quantity} left in stock!`);
    } else {
      var new_html = `<p class="product__inventory" id="Inventory-${dataSection}" role="status">
                                <span>Hurry, only ${remaining_quantity} left in stock!</span>
                            </p>`;
      remaining_quantity_div.append(new_html);
    }
    if (remaining_quantity_bar.length > 0) {
      var percentage = (remaining_quantity * 100) / 16;
      remaining_quantity_bar.css("width", percentage + "%");
    } else {
      var percentage = (remaining_quantity * 100) / 16;
      var progressHTML = `
            <div class="inventory-progress-container">
              <div class="inventory-progress-bar" style="width: ${percentage}%;"></div>
            </div>
          `;
      remaining_quantity_div.append(progressHTML);
    }
  } else {
    if (!remaining_quantity_div.hasClass("quantity_hide")) {
      remaining_quantity_div.addClass("quantity_hide");
    }
  }
}

function renderProductPrice(product) {
  const hasComparePrice =
    product.compare_at_price && product.compare_at_price > 0;
  const price = product.price || 0;
  const comparePrice = product.compare_at_price || 0;

  // ✅ Corrected formatPrice
  const formatPrice = (amountInCents) => {
  const moneyFormat =
    document.querySelector(".price_filter_price")?.dataset.moneyFormat;

  const amount = amountInCents / 100;

  // Shopify-style formatting
  const formats = {
    amount: amount.toFixed(2),
    amount_no_decimals: Math.round(amount).toString(),
    amount_with_comma_separator: amount
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, "."),
    amount_with_space_separator: amount
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, " "),
  };

  if (!moneyFormat) return formats.amount;

  return moneyFormat.replace(
    /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_with_space_separator)\s*\}\}/g,
    (match, key) => formats[key]
  );
};

  // Show free shipping badge only when price >= $170
  const FREE_SHIPPING_THRESHOLD_CENTS = price/100;
  const freeShippingHtml = FREE_SHIPPING_THRESHOLD_CENTS >=   170
    ? `<div class="price_freeshipping"><span></span><p>Free Shipping</p></div>`
    : "";

  let priceHtml;

  if (hasComparePrice) {
    priceHtml = `
      <div class="price price--large price--on-sale price--show-badge">
        <div class="price__container">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${formatPrice(
              comparePrice
            )}</span>
          </div>
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span><s class="price-item price-item--regular">${formatPrice(
              comparePrice
            )}</s></span>
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <span class="price-item price-item--sale price-item--last">${formatPrice(
              price
            )}</span>
          </div>
          <small class="unit-price caption hidden">
            <span class="visually-hidden">Unit price</span>
            <span class="price-item price-item--last">
              <span></span>
              <span aria-hidden="true">/</span>
              <span class="visually-hidden">&nbsp;per&nbsp;</span>
              <span></span>
            </span>
          </small>
          ${freeShippingHtml}
        </div>
        <span class="badge price__badge-sale color-scheme-4"> On Sale </span>
        <span class="badge price__badge-sold-out color-scheme-3"> Sold Out </span>
      </div>
    `;
  } else {
    priceHtml = `
      <div class="price price--large price--show-badge">
        <div class="price__container">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${formatPrice(
              price
            )}</span>
          </div>
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span><s class="price-item price-item--regular"></s></span>
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <span class="price-item price-item--sale price-item--last">${formatPrice(
              price
            )}</span>
          </div>
          <small class="unit-price caption hidden">
            <span class="visually-hidden">Unit price</span>
            <span class="price-item price-item--last">
              <span></span>
              <span aria-hidden="true">/</span>
              <span class="visually-hidden">&nbsp;per&nbsp;</span>
              <span></span>
            </span>
          </small>
          ${freeShippingHtml}
        </div>
        <span class="badge price__badge-sale color-scheme-4"> On Sale </span>
        <span class="badge price__badge-sold-out color-scheme-3"> Sold Out </span>
      </div>
    `;
  }

  return priceHtml;
}

jQuery(document).ready(function ($) {
  setTimeout(function () {
    var activeLink = $(".sibling-product-link.active");
    var bgColor = activeLink.data("bg");
    var textColor = activeLink.data("color");

    if (bgColor || textColor) {
      // Update product form submit
      $(".product-form__submit").css({
        "background-color": bgColor,
        "border-color": bgColor,
        color: textColor,
      });

      $(".badge.price__badge-sale").css({
        "background-color": bgColor,
        "border-color": bgColor,
        color: textColor,
      });

      // Update utility bar background
      $(".utility-bar.gradient").css({
        "background-color": bgColor,
      });
      
 // Update Custom bar background
      $(".info_popup_main").css({
        "background-color": bgColor,
      });
      

      // ✅ Cart count — with observer
      const applyCartColor = () => {
        $(".cart-count-bubble").css({
          "background-color": bgColor,
          color: textColor,
        });
      };

      applyCartColor(); // run once

      // Watch for re-render
      const cartObserver = new MutationObserver(() => applyCartColor());
      const cartTarget = document.querySelector(".header__icon--cart");
      if (cartTarget) {
        cartObserver.observe(cartTarget, { childList: true, subtree: true });
      }

      // Update announcement colors
      $(
        ".localization-wrapper a,.announcemnt_bar_slider_inner a, .announcement-bar__link .icon-arrow, .announcement_button a, .announcement-bar__announcement p"
      ).css({
        color: textColor,
        "border-color": textColor,
      });
    }
  }, 2000);

  $(".sibling-product-link ").click(function (e) {
    e.preventDefault();

    $(".product_siblings_main .sibling-product-link").removeClass("active");
    $(this).addClass("active");
    // Get color value from data-color attribute
    var bgColor = $(this).data("bg");
    var textColor = $(this).data("color");

    setTimeout(function () {
      if (bgColor || textColor) {
        // Update product form submit
        $(".product-form__submit").css({
          "background-color": bgColor,
          "border-color": bgColor,
          color: textColor,
        });

        $(".badge.price__badge-sale").css({
          "background-color": bgColor,
          "border-color": bgColor,
          color: textColor,
        });

        // Update utility bar background
        $(".utility-bar.gradient").css({
          "background-color": bgColor,
        });

         // Update Custom bar background
      $(".info_popup_main").css({
        "background-color": bgColor,
      });
      
        // ✅ Cart count — with observer
        const applyCartColor = () => {
          $(".cart-count-bubble").css({
            "background-color": bgColor,
            color: textColor,
          });
        };

        applyCartColor(); // run once

        const cartObserver = new MutationObserver(() => applyCartColor());
        const cartTarget = document.querySelector(".header__icon--cart");
        if (cartTarget) {
          cartObserver.observe(cartTarget, { childList: true, subtree: true });
        }

        // Update announcement colors
        $(
          ".localization-wrapper a,.announcemnt_bar_slider_inner a, .announcement-bar__link .icon-arrow, .announcement_button a, .announcement-bar__announcement p"
        ).css({
          color: textColor,
          "border-color": textColor,
        });
      }
    }, 100);

    var productId = $(this).data("id");
    var productHandle = $(this).data("handle");
    $.ajax({
      url: "/products/" + productHandle + ".js",
      method: "GET",
      dataType: "json",
      mode: "no-cors", // This disables CORS checks
      success: function (product) {
        const mainPriceDiv = $(".main_product_price");
        mainPriceDiv.html(renderProductPrice(product));

        // Check inside the <variant-selects> tag for .product-form__input
        const variantInputs = $("variant-selects .product-form__input");
        if (!variantInputs.length) {
          // Extract the price text
          let gettxt = $(
            ".product__info-wrapper.grid__item .price-item.price-item--last"
          ).text();

          // Clean the price string
          let cleanedPrice = gettxt
            .replace(/[^$0-9.,]/g, "")
            .replace(/^\./, "");

          console.log(cleanedPrice, "cleanedPrice");

          // Update the button or target element
          $(".btn_price").text(cleanedPrice);
        }

        const cartButton = $(".product-form__submit.button");
        const variantInput = $(".product-variant-id"); // Select the hidden input field

        if (cartButton.length) {
          if (product.available) {
            cartButton.find(".btn_inside_txt").text("Add to cart");
            cartButton.prop("disabled", false);
          } else {
            cartButton.find(".btn_inside_txt").text("Sold out");
            cartButton.prop("disabled", true);
          }
        }
        if (variantInput.length && product.variants.length > 0) {
          variantInput.val(product.variants[0].id); // Get the first variant ID
        }
        if (
          typeof BIS !== "undefined" &&
          typeof BIS.refreshInlineButton === "function"
        ) {
          console.log("before");
          BIS.refreshInlineButton();
          console.log("after");
        }
        if (product.available) {
          $("#BIS_trigger").hide(); // Hide if product is in stock
        } else {
          $("#BIS_trigger").show(); // Show if out of stock
        }
        var metafields = dishMetaFields[productHandle];
        if (metafields && metafields.sibling_title) {
          $(".product_siblings_main h3 span").text(metafields.sibling_title);
        } else {
          //  $(".product_siblings_main h3 span").text('');
          var colorText = product.title.split(" ").pop();
          $(".product_siblings_main h3 span").text(colorText);
        }

        /*  var preOrderDateDiv = $(".preorder_date");
        
                var preOrderDateHidden = $(".pre_order_date_class");
                if (metafields && metafields.preorder_date) {
                  var PreorderDate = metafields.preorder_date;
                  preOrderDateHidden.val(PreorderDate);
                } else {
                  preOrderDateHidden.val("");
                }
        
                if (metafields && metafields.variant_preorder_date) {
                  var variantPreorderDate = metafields.variant_preorder_date;
                  preOrderDateDiv.html(
                    "<p>Preorder Shipping on " + variantPreorderDate + "</p>"
                  );
                } else {
                  preOrderDateDiv.html("");
                }
                */
        const galleryContainer = document.getElementById(
          "product-masonry-gallery"
        );
        if (galleryContainer) {
          galleryContainer.innerHTML = "";
          if (
            metafields &&
            metafields.product_images_gallery &&
            metafields.product_images_gallery.length
          ) {
            for (let i = 0; i < metafields.product_images_gallery.length; i++) {
              const imageUrl = metafields.product_images_gallery[i];

              const galleryItem = document.createElement("div");
              galleryItem.className = "gallery-item";

              const img = document.createElement("img");
              img.src = imageUrl + "?width=1024"; // Shopify CDN resize
              img.alt = productTitle + " image " + (i + 1);

              galleryItem.appendChild(img);
              galleryContainer.appendChild(galleryItem);
            }
          }
        }
        if (
          metafields &&
          metafields.dropdown_tabs &&
          metafields.dropdown_tabs.length > 0
        ) {
          if (Array.isArray(metafields.dropdown_tabs)) {
            dropdown_tabs_raw = metafields.dropdown_tabs.join("").trim();
          } else if (typeof metafields.dropdown_tabs === "string") {
            dropdown_tabs_raw = metafields.dropdown_tabs.trim();
          } else {
            dropdown_tabs_raw = "";
          }
          var tabsMainContainer = document.querySelector(
            ".custom-tab-button-main"
          );
          if (!tabsMainContainer) {
            // tabsMainContainer.innerHTML = "";
          } else {
            var cleanedTabs = dropdown_tabs_raw
              .replace(/^\[\\"|\\"]$/g, "")
              .replace(/^\[|\]$/g, "");

            var dropdown_tabs = cleanedTabs.split(",").map(function (item) {
              return item
                .replace(/['"\[\]]/g, "") // Removes stray " ' [ ]
                .replace(/&quot;/g, '"') // Converts HTML entity for double quotes to "
                .replace(/&#39;/g, "'") // Converts HTML entity for single quote to '
                .trim(); // Trims any whitespace
            });
            var tabsMainContainer = document.querySelector(
              ".custom-tab-button-main"
            );
            if (tabsMainContainer) {
              tabsMainContainer.innerHTML = "";
            }
            dropdown_tabs.forEach(function (item, index) {
              var titleDescription = item.split(":");
              var title = titleDescription[0]
                ? titleDescription[0].trim().replace(/^"|"$/g, "")
                : ""; // Remove leading/trailing quotes from title
              var description = titleDescription[1]
                ? titleDescription[1].trim().replace(/^"|"$/g, "")
                : ""; // Remove leading/trailing quotes from description
              if (title !== "" && description !== "") {
                var buttonDiv = document.createElement("div");
                buttonDiv.classList.add("button_inner");
                var button = document.createElement("button");
                button.classList.add("custom-tab-button");
                button.setAttribute("data-tab", "tab" + (index + 1));
                button.setAttribute("aria-controls", "tab" + (index + 1));
                button.setAttribute("aria-selected", "false");
                button.innerHTML =
                  title +
                  `
                                    <span>
                                      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                                      </svg>
                                    </span>`;
                var tabContent = document.createElement("div");
                tabContent.id = "tab" + (index + 1);
                tabContent.classList.add("tab_new");
                tabContent.style.display = "none";
                tabContent.innerHTML = "<p>" + description + "</p>";
                buttonDiv.appendChild(button);
                buttonDiv.appendChild(tabContent);
                if (tabsMainContainer) {
                  tabsMainContainer.appendChild(buttonDiv);
                }
                // tabsMainContainer.appendChild(buttonDiv);
              }
            });
            $(".custom-tab-button").click(function () {
              var tab_id = $(this).attr("data-tab");
              var tab_content = $("#" + tab_id);

              // Slide toggle the clicked tab's content
              tab_content.slideToggle(300); // Adjust duration (300ms) as needed

              // Optionally update the active class
              $(".custom-tab-button")
                .removeClass("active")
                .attr("aria-selected", "false");
              $(this)
                .toggleClass("active")
                .attr("aria-selected", tab_content.is(":visible"));
            });
            console.log("end");
          }

        } else {
          console.log("dropdown_tabs metafield is missing for this product.");
        }

        var descount_text_element = $(".meta_discount_text");
        if (metafields && metafields.discount_text) {
          var discount_text = metafields.discount_text;
          descount_text_element.html("<span>" + discount_text + "</span>");
        } else {
          descount_text_element.empty();
        }
        var description_list_element = $(".metafield_description_lists");
        if (metafields && metafields.description_points) {
          var description_points = metafields.description_points;
          description_list_element.html(description_points);
        } else {
          description_list_element.html("");
        }

        // metafield product description work
        var $ulElement = $(".metafield-single_line_text_field-array");
        if (metafields && metafields.description_bullet_points) {
          var description_bullet_points =
            metafields.description_bullet_points.replace(
              /&quot;&quot;/g,
              "&quot;"
            );
          description_bullet_points = description_bullet_points.replace(
            /&quot;/g,
            '"'
          );
          description_bullet_points = JSON.parse(description_bullet_points); // Make sure it's an array

          $ulElement.empty();

          $.each(description_bullet_points, function (index, point) {
            $ulElement.append(
              '<li class="metafield-single_line_text_field">' + point + "</li>"
            );
          });
        } else {
          $ulElement.empty();
        }
        if (metafields && metafields.composition_care) {
          var composition_care =
            '<p><span class="metafield-multi_line_text_field">' +
            metafields.composition_care +
            "</span></p>";
          $(
            ".accordion__content.rte.product_metafield_description.COMPOSITION-AND-CARE"
          ).html(composition_care);
        } else {
          $(
            ".accordion__content.rte.product_metafield_description.COMPOSITION-AND-CARE"
          ).html("");
        }
        if (metafields && metafields.shipping_delivery) {
          var shipping_delivery =
            '<p><span class="metafield-multi_line_text_field">' +
            metafields.shipping_delivery +
            "<span></p>";
          $(
            ".accordion__content.rte.product_metafield_description.SHIPPING-AND-DELIVERY"
          ).html(shipping_delivery);
        } else {
          $(
            ".accordion__content.rte.product_metafield_description.SHIPPING-AND-DELIVERY"
          ).html("");
        }
        if (metafields && metafields.zorali_promises) {
          var zorali_promises =
            '<p><span class="metafield-multi_line_text_field">' +
            metafields.zorali_promises +
            "</span></p>";
          $(
            ".accordion__content.rte.product_metafield_description.ZORALI-PROMISES"
          ).html(zorali_promises);
        } else {
          $(
            ".accordion__content.rte.product_metafield_description.ZORALI-PROMISES"
          ).html("");
        }

        // var descriptionbulletpoints = JSON.parse(description_bullet_points);
        // console.log(descriptionbulletpoints,metafields.composition_care,metafields.zorali_promises,metafields.shipping_delivery, "metafields");

        // metafield highlight tabs work
        const mycontainer = $(".highlight-tabs-buttons");

        // Check if metafields or tabs_highlight exist and are not empty
        if (metafields && metafields.tabs_highlight) {
          // console.log(metafields.tabs_highlight, "metafields.tabs_highlight");

          // Decode HTML-encoded quotes (&quot;) back to regular quotes
          var tabsHighlight = metafields.tabs_highlight.replace(/&quot;/g, '"');

          try {
            // Parse the JSON string
            var highlights = JSON.parse(tabsHighlight);

            // console.log(highlights, "highlights");

            // Clear the container before adding new buttons
            mycontainer.empty();

            // Loop through the parsed array
            highlights.forEach(function (item) {
              // Split each item by ': ' to separate the heading and description
              let [heading, description] = item.split(": ");

              // Ensure both heading and description are valid before proceeding
              if (heading && description) {
                // Trim any leading or trailing whitespace
                heading = heading.trim();
                description = description.trim();

                // Create the button HTML
                const buttonHTML = `
                                   <button class="highlight-tab-button" data-heading="${heading}" data-description="${description}">
                                       ${heading}
                                   </button>
                               `;

                // Append the button to the container
                mycontainer.append(buttonHTML);
                // Add the new button based on the clicked highlight-tab-button
              }
            });

            // Add event listener to handle button clicks and toggle the active class
            $(".highlight-tab-button").on("click", function () {
              // Remove active class from all buttons
              $(".highlight-tab-button").removeClass("active");

              // Add active class to the clicked button
              $(this).addClass("active");

              // Get the heading and description from the clicked button
              const tabHeading = $(this).data("heading");
              const description = $(this).data("description");

              // Display the popup
              $("#highlight-popup").css("display", "block");

              // Update the popup's heading and description
              $("#highlight-popup .highlight_inside_heading h4").text(
                tabHeading
              );
              $("#highlight-popup-description").text(description);

              // Replace the buttons in the popup-tab-headers div with the current buttons
              const popupTabHeaders = $(".popup-tab-headers");

              // Clear the existing buttons in popup-tab-headers
              popupTabHeaders.empty();
              highlights.forEach(function (item) {
                let [heading, description] = item.split(": ");
                heading = heading.trim();
                description = description.trim();

                // Create button HTML
                const newButtonHTML = `
                                    <button class="popup-tab-header" data-heading="${heading}" data-description="${description}">
                                        ${heading}
                                    </button>
                                `;

                popupTabHeaders.append(newButtonHTML);
                if (heading === tabHeading) {
                  popupTabHeaders
                    .find(`button[data-heading="${heading}"]`)
                    .addClass("active");
                }
              });
              // Append the popup to the target div
              const targetDiv = document.querySelector(
                ".page-width .product--columns"
              );
              if (targetDiv) {
                targetDiv.appendChild(
                  document.getElementById("highlight-popup")
                );
                document.getElementById("highlight-popup").style.display =
                  "block";
              }
            });

            // Close the popup when the close button is clicked
            $(".highlight-close").on("click", function () {
              $("#highlight-popup").css("display", "none");
            });

            $(document).on(
              "click",
              "#highlight-popup .popup-tab-header",
              function () {
                $(".popup-tab-header").removeClass("active");
                $(this).addClass("active");
                const tabHeading = $(this).data("heading");
                const description = $(this).data("description");
                $("#highlight-popup").css("display", "block");
                $("#highlight-popup .highlight_inside_heading h4").text(
                  tabHeading
                );
                $("#highlight-popup-description").text(description);

                // Select the div containing the buttons
                const $highlightTabsButtons = $(".highlight-tabs-buttons");

                // Remove the 'active' class from all buttons
                $highlightTabsButtons
                  .find(".highlight-tab-button")
                  .removeClass("active");

                // Add 'active' class to the button with matching data-heading value
                $highlightTabsButtons
                  .find(`.highlight-tab-button[data-heading="${tabHeading}"]`)
                  .addClass("active");
              }
            );
          } catch (error) {
            console.error("Error parsing tabs_highlight JSON:", error);
          }
        } else {
          // Remove the HTML if there's no tabs_highlight data
          mycontainer.empty();
          // console.log("No tabs_highlight available for this product.");
        }

        var productInfo = $("product-info");
        productInfo.attr("data-product-id", product.id);
        productInfo.attr("data-url", "/products/" + product.handle);
        var newUrl = "/products/" + product.handle;
        window.history.pushState({ path: newUrl }, "", newUrl);
        // var price = '{{ product.price }}';
        // var formattedPrice = formatMoney(product.price);
        $("#modal-size-chart-heading").html(product.title);
        $(".product__title").html("<h1>" + product.title + "</h1>");
        // $('.price-item.price-item--regular').text(formattedPrice);

        // Container to append the generated HTML
        var container = $(".product__media-list.contains-media.grid"); // Change this to the ID of the element you want to append to
        var containerID = container.attr("id");
        var numericId = containerID.match(/\d+/)[0];

        // If the info popup lives inside the container, save it before we clear the container
        // so we can re-insert it after rendering the media items.
        var $popupMainSaved = $();
        if (container.length) {
          var $foundPopup = container.find(".info_popup_main");
          if ($foundPopup.length) {
            // detach keeps data & events but removes from DOM
            $popupMainSaved = $foundPopup.detach();
          }
        }
        console.log(metafields.image_alt_text, "product.image_alt_text");
        // Clear container (we already detached the popup if it was inside)
        container.html("");
        var productTitle = product.title;
        var productModel = $(
          "#ProductModal-template--" +
            numericId +
            "__main .product-media-modal__content"
        );
        productModel.html("");
        product.media.forEach(function (mediaItem, index) {
          var media_id = mediaItem.id;
          var mediaId = `template--${numericId}__main-${media_id}`;
          var mediaalt = mediaItem.alt;
          var template = `template--${numericId}__main`;
          var listItem = "";
          var productModelItem = "";
          // Check the media type
          if (mediaItem.media_type === "image") {
            var imgUrl = mediaItem.src;
            listItem = `
            <li id="Slide-${mediaId}" class="product__media-item grid__item slider__slide scroll-trigger animate--fade-in" data-media-id="${mediaId}">
                <div class="product-media-container media-type-image media-fit-contain global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
                    <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-${template}">
                        <span class="product__media-icon motion-reduce quick-add-hidden product__media-icon--none" aria-hidden="true">
                            <svg aria-hidden="true" focusable="false" class="icon icon-plus" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"></path>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"></path>
                            </svg>
                        </span>
                        <div class="product__media media media--transparent">
                            <img src="${imgUrl}" alt="" class="image-magnify-none">
                        </div>
                         ${
                           mediaalt
                             ? `<span class="media__alt">${mediaalt}</span>`
                             : ""
                         }
                        <button class="product__media-toggle quick-add-hidden product__media-zoom-none" type="button" aria-haspopup="dialog" data-media-id="${media_id}">
                            <span class="visually-hidden">Open media ${
                              index + 1
                            } in modal</span>
                        </button>
                    </modal-opener>
                </div>
            </li>`;
            productModelItem = `<img class="global-media-settings global-media-settings--no-shadow" srcset="${imgUrl}&amp;width=550 550w,${imgUrl}&amp;width=1100 1100w,${imgUrl}&amp;width=1445 1445w,${imgUrl} 1500w" sizes="(min-width: 750px) calc(100vw - 22rem), 1100px" src="${imgUrl}&amp;width=1445" alt="Trailblazer Sandal Sage" loading="lazy" width="1100" height="1100" data-media-id="${media_id}">`;
          } else if (mediaItem.media_type === "video") {
            var video_image = mediaItem.preview_image.src;
            var video = mediaItem.sources[0].url;
            var video_type = mediaItem.sources[0].mime_type;
            listItem = `
            <li id="Slide-${mediaId}" class="product__media-item grid__item slider__slide product__media-item--full scroll-trigger animate--fade-in" data-media-id="${mediaId}">
                <div class="product-media-container media-type-video media-fit-contain global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
                    <modal-opener class="product__modal-opener product__modal-opener--video" data-modal="#ProductModal-${template}">
                        <span class="product__media-icon motion-reduce quick-add-hidden" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-play" fill="none" viewBox="0 0 10 14">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"></path>
                            </svg>
                        </span>
                        <div class="loading__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66"
                               xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                        <div class="product__media media media--transparent">
                            <img src="${video_image}&amp;width=1946"
                                 alt=""
                                 srcset="${video_image}&amp;width=246 246w, ${video_image}&amp;width=493 493w, ${video_image}&amp;width=600 600w, ${video_image}&amp;width=713 713w, ${video_image}&amp;width=823 823w, ${video_image}&amp;width=990 990w, ${video_image}&amp;width=1100 1100w, ${video_image}&amp;width=1206 1206w, ${video_image}&amp;width=1346 1346w, ${video_image}&amp;width=1426 1426w, ${video_image}&amp;width=1646 1646w, ${video_image}&amp;width=1946 1946w"
                                 width="1946" height="1946" loading="lazy"
                                 sizes="(min-width: 1400px) 423px, (min-width: 990px) calc(32.5vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                        </div>
                        <button class="product__media-toggle quick-add-hidden product__media-zoom-none" type="button" aria-haspopup="dialog" data-media-id="${media_id}">
                            <span class="visually-hidden">Open video ${
                              index + 1
                            } in modal</span>
                        </button>
                    </modal-opener>
                    <deferred-media class="deferred-media media media--transparent" data-media-id="${media_id}">
                        <button id="Deferred-Poster-Modal-${media_id}" class="deferred-media__poster" type="button">
                        <span class="deferred-media__poster-button motion-reduce"><span
                                    class="visually-hidden">Play video</span><svg
                                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                    class="icon icon-play"
                                    fill="none" viewBox="0 0 10 14">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z"
                                  fill="currentColor"></path>
                        </svg>
                        </span>
                        <img src="${video_image}&amp;width=1946"
                             alt=""
                             srcset="${video_image}&amp;width=246 246w, ${video_image}&amp;width=493 493w, ${video_image}&amp;width=600 600w, ${video_image}&amp;width=713 713w, ${video_image}&amp;width=823 823w, ${video_image}&amp;width=990 990w, ${video_image}&amp;width=1100 1100w, ${video_image}&amp;width=1206 1206w, ${video_image}&amp;width=1346 1346w, ${video_image}&amp;width=1426 1426w, ${video_image}&amp;width=1646 1646w, ${video_image}&amp;width=1946 1946w"
                             width="1946" height="1946" loading="lazy"
                             sizes="(min-width: 1400px) 423px, (min-width: 990px) calc(32.5vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                            </button>
                        <template>
                            <video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none"
                                   muted="muted" aria-label="${video_image}"
                                   poster="${video_image}">
                                <source src="${video}"
                                        type="${video_type}">
                                <img src="${video_image}">
                            </video>
                        </template>
                    </deferred-media>
                </div>
            </li>`;
          }
          productModelItem = `<deferred-media class="deferred-media media global-media-settings global-media-settings--no-shadow active" style="padding-top: min(calc(100vh - 12rem), 100.0%)" data-media-id="${media_id}">
                                <button id="Deferred-Poster-Modal-${media_id}" class="deferred-media__poster" type="button">
                                  <span class="deferred-media__poster-button motion-reduce"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-play" fill="none" viewBox="0 0 10 14">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"></path>
                                  </svg>
                                  </span>
                                    <img srcset="${video_image}&amp;width=288 288w,
                                              ${video_image}&amp;width=576 576w,
                                              ${video_image}&amp;width=550 550w,
                                              
                                              ${video_image} 1080w" src="${video_image}&amp;height=550&amp;v=1730775550&amp;width=550" sizes="(min-width: 1200px) calc((1200px - 10rem) / 2), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="576" height="576.0" alt="">
                                  </button>
                                  <template>
                                  <video playsinline="playsinline" controls="controls" autoplay="autoplay" preload="none" muted="muted" aria-label="${video_image}" poster="${video_image}">
                                  <source src="${video}" type="${video_type}"><img src="${video_image}"></video>
                                </template>
                              </deferred-media>`;

          container.append(listItem);
          productModel.append(productModelItem);
        });

        // If we saved a popup earlier, insert it after the 4th item (desktop only)
        if ($(window).width() > 992) {
          // sirf 992px se upar
          var $lis = container.find("li");

          if (container.length && $lis.length >= 4 && $popupMainSaved.length) {
            $lis.eq(3).after($popupMainSaved); // 4th li ke baad append
          } else if (container.length && $lis.length >= 4) {
            // fallback: maybe popup exists elsewhere on page; try to find it globally
            var $popupMainGlobal = $(".info_popup_main");
            if ($popupMainGlobal.length) {
              $lis.eq(3).after($popupMainGlobal);
            }
          }

          // Bind popup open/close handlers (ensure handlers are not duplicated)
          $(document)
            .off("click", ".info_popup_main")
            .on("click", ".info_popup_main", function () {
              $(this).siblings(".info_popup_overlay").fadeIn(200);
            });

          $(document)
            .off("click", ".close_popup, .info_popup_overlay")
            .on("click", ".close_popup, .info_popup_overlay", function (e) {
              if (
                $(e.target).is(".close_popup") ||
                $(e.target).is(".info_popup_overlay")
              ) {
                $(".info_popup_overlay").fadeOut(200);
              }
            });
        }

        var thumbnailSlider = $(
          "#GalleryThumbnails-template--" + numericId + "__main ul"
        );
        thumbnailSlider.html("");
        product.media.forEach(function (mediaItem, index) {
          var media_id = mediaItem.id;
          var mediaId = `template--${numericId}__main-${media_id}`;
          var mediaWithIndex = `template--${numericId}__main-${index}`;
          thumbnailItem = "";
          if (mediaItem.media_type === "image") {
            var imgUrl = mediaItem.src;
            var thumbnailItem = `
                                <li id="Slide-Thumbnails-${mediaId}" class="thumbnail-list__item slider__slide" data-target="${mediaId}" data-media-position="${media_id}">
                                    <button class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="Load image ${
                                      index + 1
                                    } in gallery view" aria-controls="GalleryViewer-template--${numericId}__main" aria-describedby="Thumbnail-${mediaId}">
                                        <img src="${imgUrl}" alt="Thumbnail image ${
              index + 1
            }" width="416" height="416" loading="lazy" class="thumbnail-img" id="Thumbnail-${mediaId}">
                                    </button>
                                </li>`;
          } else if (mediaItem.media_type === "video") {
            var video_image = mediaItem.preview_image.src;
            var video = mediaItem.sources[0].url;
            var video_type = mediaItem.sources[0].mime_type;

            var thumbnailItem = `
                                <li id="Slide-Thumbnails-${mediaId}" class="thumbnail-list__item slider__slide" data-target="${mediaId}" data-media-position="${media_id}">
                                    <span class="thumbnail__badge" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-play" fill="none" viewBox="0 0 10 14">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"></path>
                                      </svg>
                                    </span>
                                    <button class="thumbnail global-media-settings global-media-settings--no-shadow" aria-label="Load image ${
                                      index + 1
                                    } in gallery view" aria-controls="GalleryViewer-template--${numericId}__main" aria-describedby="Thumbnail-${mediaId}">
                                        <img src="${video_image}" alt="Thumbnail image ${
              index + 1
            }" width="416" height="416" loading="lazy" class="thumbnail-img" id="Thumbnail-${mediaId}">
                                    </button>
                                </li>`;
          }

          thumbnailSlider.append(thumbnailItem);
        });

        // Event Listener for thumbnails
        thumbnailSlider.on("click", ".thumbnail", function () {
          var mediaId = $(this).closest("li").data("target");

          // Check if mediaGallery is available
          const mediaGallery = document.querySelector("media-gallery");
          if (mediaGallery) {
            // Call setActiveMedia on the mediaGallery instance
            mediaGallery.setActiveMedia(mediaId, false);
          }
        });

        // Wait for the custom element to be available
        // const mediaGallery = document.querySelector('media-gallery');

        // Ensure the custom element exists
        // if (mediaGallery) {
        // Call setActiveMedia on the mediaGallery instance
        // mediaGallery.setActiveMedia('your-media-id', false); // Replace 'your-media-id' with the actual media ID you want to pass
        // }

        var description = $(".product__description.rte.quick-add-hidden");
        description.html(product.description);

        var newProductData = {
          tags: product.tags.join(","), // Assuming tags is an array
          type: product.type || "", // Handle undefined values
          product: product.id,
          vendor: product.vendor || "",
          // collections: product.collections.map(c => c.id).join(','),
        };

        const elementToInject = document.getElementById("main-size-content");
        if (elementToInject) {
          // Clear any existing content
          elementToInject.innerHTML = "";

          // Check if the KiwiSizing library is available and has the required method
          if (window.ks && typeof window.ks.loadSizing === "function") {
            // Load the size chart using KiwiSizing
            window.ks.loadSizing({
              productData: newProductData,
              options: {
                el: elementToInject, // Target the KiwiSizingChart element
                displayMode: 0, // Display size chart inline
              },
              loaded: function (success) {
                if (success) {
                  console.log("KiwiSizing loaded successfullyyy.");
                } else {
                  console.log("Failed to load KiwiSizing.");
                }
              },
            });
          } else {
            console.log("KiwiSizing library is not available.");
          }
        } else {
          console.error("Element with ID 'KiwiSizingChart' not found.");
        }
        const orignalButton = document.getElementById("KiwiSizingChart");
        orignalButton.innerHTML = "";

        var variantFieldset = $(".js.product-form__input .cstm_label_main");
        //variantFieldset.empty(); here for not hiding size container

        // var legend = '<legend class="form__label">Size</legend>';
        // variantFieldset.append(legend);
        var variantSelects = new VariantSelects();
        /*   var existingScript = document.getElementById(
                  "back-in-stock-helper-embedded"
                );
                var productData = JSON.stringify(product); // Convert JSON to a string
        
                // Generate the new script content
                var updatedScriptContent = `
                    var _BISConfig = _BISConfig || {};
                    _BISConfig.product = ${productData};
                
                    // Update inventory quantities dynamically based on the response
                    ${product.variants
                      .map(
                        (variant, index) => `
                        _BISConfig.product.variants[${index}]['inventory_quantity'] = ${
                          variant.available ? variant.inventory_quantity : 0
                        };
                    `
                      )
                      .join("")}
                `;
        
                // If the script exists, update its content; otherwise, create a new script
                if (existingScript) {
                  existingScript.textContent = updatedScriptContent;
                }
        
        */
        /* product.variants.forEach(function (variant, index) {
                          var variantId = "template--" + product.id + "-1-" + index;
                          var variantValue = variant.option1;
                          var variantAvailable = variant.available ? "" : "disabled";
                          var variantSoldOut = variant.available
                            ? ""
                            : '<span class="visually-hidden label-unavailable">Variant sold out or unavailable</span>';
        
                          var radioInput = `<div class="cstm_option_label"><input type="radio" id="${variantId}" name="Size-1" value="${variantValue}" ${variantAvailable} data-option-value-id="${variant.id}" >
                                    <label data-price="${variant.price}" for="${variantId}">${variantValue} ${variantSoldOut}</label></div>`;
        
                          variantFieldset.append(radioInput);
                          if (index === 0) {
                            $("#" + variantId)
                              .prop("checked", true)
                              .trigger("change");
                          }
                        }); */
        const variantSelectElement = document.querySelector("variant-selects");
        if (variantSelectElement) {
          const event = new Event("change");
          variantSelectElement.dispatchEvent(event);
        }

        /*     let iframe = $("#BIS_frame"); // Replace 'iframe-id' with the actual ID or selector of the iframe.
        
                if (iframe.length) {
                  // Access the iframe's content
                  let iframeContent = iframe.contents();
                  var title = $(".product__info-container .product__title h1").text();
                  // Change the modal title inside the iframe
                  iframeContent.find(".product-name").text(title);
                  let select = iframeContent.find("#variants");
                  const unavailableVariants = product.variants.filter(
                    (variant) => !variant.available
                  );
                  select.empty(); // Clear current options
                  unavailableVariants.forEach(function (variant) {
                    select.append(
                      '<option value="' +
                        variant.id +
                        '" >' +
                        variant.title +
                        "</option>"
                    );
                  });
                } else {
                  console.error("Iframe not found!");
                } */

        // get_meta_fields(product.id);
        var sticy_header = $(".sticky-atc .page-width .footerstimainbox");

        sticy_header
          .find(".footerstiimg")
          .html(`<img src="` + product.featured_image + `">`);
        sticy_header.find(".foooterprotitle").html(product.title);
        // Initialize an empty string to store option HTML
        let optionsHtml = "";

        setTimeout(() => {
          let parentDiv = document.getElementById("model-size-content");

          if (parentDiv && parentDiv.children.length > 1) {
            console.log("Showing modal button");
            $("#openModalBtn").show();
          } else {
            console.log("Hiding modal button");
            $("#openModalBtn").hide();
          }
        }, 2000);
        if (typeof BIS !== "undefined" && BIS.Config) {
          _BISConfig.product = product;

          BIS.Config.product = product;
          BIS.popup.product = product;
          BIS.popup.settings.product = product;

          const existingIframe = document.querySelector("iframe#BIS_frame");
          if (existingIframe) {
            existingIframe.remove();
            console.log("Removed existing iframeee.");
          }

          BIS.Config.multivariant_dropdown_container = document;
          window.BISConfig = BIS.Config;

          BIS.domReady().then(BIS.init);

          BIS.domReady().then(function () {
            // Check if this is a product page
            if (BIS.urlIsProductPage()) {
              BIS.popup.ready.then(function () {
                // Ensure that there are variants available to check
                if (BIS.popup.variants.length > 0) {
                  console.log("123123123");
                  // Check if the button already exists in the DOM
                  const existingButton = document.getElementById("BIS_trigger");

                  // If the button exists, remove it
                  if (existingButton) {
                    existingButton.remove();
                    console.log("Existing Notify button removed.");
                  }

                  // Create the Notify Me button
                  const notifyButton = document.createElement("button");
                  notifyButton.setAttribute("id", "BIS_trigger");
                  notifyButton.setAttribute("type", "button");
                  notifyButton.setAttribute(
                    "class",
                    "product-form__submit button button--full-width button--primary"
                  );
                  notifyButton.textContent = BIS.currentButtonCaption();
                  notifyButton.setAttribute(
                    "aria-label",
                    notifyButton.textContent
                  );

                  // Insert the button after the main product submit button
                  BIS.inlineButtonAnchor = ".product-form__submit";
                  const submitButton = document.querySelector(
                    BIS.inlineButtonAnchor
                  );
                  if (submitButton) {
                    submitButton.insertAdjacentElement(
                      "afterend",
                      notifyButton
                    );
                    console.log("New Notify button created.");
                  }

                  // Store the initial display state for reuse
                  const initialDisplayState = notifyButton.style.display;

                  // Function to update the button's visibility based on variant availability
                  BIS.refreshInlineButton = function () {
                    try {
                      const currentVariant = BIS.detectVariant(BIS.popup);

                      // Check if the current variant is unavailable
                      if (
                        currentVariant &&
                        BIS.popup.variantIsUnavailable(currentVariant)
                      ) {
                        notifyButton.style.display = initialDisplayState; // Show the button
                      } else {
                        notifyButton.style.display = "none"; // Hide the button if available
                      }
                    } catch (error) {
                      console.log(
                        "Error refreshing the Notify Me button:",
                        error
                      );
                    }
                  };

                  // Initial check to determine if the button should be visible or not
                  BIS.refreshInlineButton();

                  // Delayed refresh function for better performance
                  BIS.delayedRefreshInlineButton = function () {
                    setTimeout(function () {
                      BIS.refreshInlineButton();
                    }, 15);
                  };

                  // Event listeners for detecting changes in the variant dropdown
                  document.addEventListener(
                    "change",
                    BIS.delayedRefreshInlineButton
                  );
                  document.addEventListener(
                    "click",
                    BIS.delayedRefreshInlineButton
                  );

                  // Check if the product is available
                  if (BIS.popup.product.available) {
                    // console.log("here1", BIS.popup.product.available, BIS)
                    const formElement = document.querySelector(
                      'form[action^="/cart/add"]'
                    );
                    if (formElement) {
                      // console.log("here2", BIS.refreshInlineButton(), BIS)
                      // Initial button refresh
                      BIS.refreshInlineButton();

                      // Add event listeners to dynamically update the button
                      formElement.addEventListener(
                        "change",
                        BIS.refreshInlineButton
                      ); // For input changes
                      formElement.addEventListener(
                        "input",
                        BIS.refreshInlineButton
                      ); // For text or quantity updates
                      formElement.addEventListener(
                        "click",
                        BIS.refreshInlineButton
                      ); // For any button clicks
                    }
                  }
                  // https://www.zorali.com/products/mens-recycled-short-slate-blue?variant=39390452613233

                  //Mutation observer to monitor changes in the product form for dynamic updates
                  //                   if (BIS.popup.product.available) {

                  //                     console.log("here1", BIS.popup.product.available, BIS)
                  //                     const formElement = document.querySelector(
                  //                       'form[action^="/cart/add"]'
                  //                     );
                  //                     if (formElement) {
                  //                       BIS.refreshInlineButton();
                  // console.log("here2")
                  //                       // Observe form changes to update button visibility
                  //                       BIS.inlineButtonObserver = new MutationObserver(function (
                  //                         mutations
                  //                       ) {
                  //                         mutations.forEach(function () {
                  //                           BIS.refreshInlineButton();
                  //                         });
                  //                       });

                  //                       BIS.inlineButtonObserver.observe(formElement, {
                  //                         childList: true,
                  //                         subtree: true,
                  //                         attributes: true,
                  //                       });
                  //                     }
                  //                   }

                  // Add an event listener for the Notify Me button click
                  notifyButton.addEventListener("click", function () {
                    // Handle button click to select the unavailable variant
                    if (BIS.popup.form && e) {
                      BIS.popup.form.selectVariant(e);
                    }
                  });
                }
              });
            }
          });
          setTimeout(() => {
            onChangeVariantAjax();
          }, 2000);
        }
      },
      error: function (xhr, status, error) {
        console.log("Error fetching product details:", error);
      },
    });
  });
});
